import useIsClient from './useIsClient'

export const useQueryParams = () => {
  const isClient = useIsClient()
  return {
    appendSearch: (url: string) => {
      if (!isClient) {
        return url
      }

      return url + location.search
    },
  }
}
